"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationSchema = void 0;
const zod_1 = require("zod");
// Схема для IPagination
exports.paginationSchema = zod_1.z.object({
  page: zod_1.z.number().min(1),
  pageSize: zod_1.z.number().min(1),
  total: zod_1.z.number().positive(),
  totalPages: zod_1.z.number().positive()
});
